import { render, staticRenderFns } from "./AddUpdatePackage.vue?vue&type=template&id=3beb08de&scoped=true"
import script from "./AddUpdatePackage.vue?vue&type=script&lang=js"
export * from "./AddUpdatePackage.vue?vue&type=script&lang=js"
import style0 from "./AddUpdatePackage.vue?vue&type=style&index=0&id=3beb08de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb08de",
  null
  
)

export default component.exports